import { Transport } from "@/transport/ITransport";
import { IOferta } from "./IOferta";
import { ILicz, Licz,Wartość } from "./Log";
import { OfertaCell } from "./OfertaCell";
import { INarzut } from "@/fin/INarzut";
import { IUser } from "@/../../server/src/user/IUser";
import { IMasterData } from "@/store/MasterData";
import { IWykrojnikRow } from "../IWykrojnikRow";

export class OfertaPricer {

    predkosc_druku=0;

    oferta:IOferta;
    rodzaj_kalkulacji:string
    narzut_procent_min:number
    narzut_procent_cel:number
    narzut_procent_max:number
    colors: number = 0
    user:IUser

    wykrojnik: IWykrojnikRow;

    indexes:any
    naklady:number[]=[]
    zmiany:number[]=[]

    prices_auto_valid:boolean=false;
    licz_w_pln = false;


    constructor(oferta:IOferta, rodzaj_kalkulacji:string, narzut_procent_min:number, narzut_procent_cel:number, narzut_procent_max:number, colors: number, user:IUser) {

        this.oferta = oferta
        this.rodzaj_kalkulacji = rodzaj_kalkulacji
        this.user = user
        this.narzut_procent_min = narzut_procent_min
        this.narzut_procent_cel = narzut_procent_cel
        this.narzut_procent_max = narzut_procent_max
        this.colors = colors

        this.wykrojnik=this.oferta.wykrojnik_sel
        this.predkosc_druku=0
        if (this.rodzaj_kalkulacji=="STARA KALKULACJA") {
          this.wykrojnik=this.oferta.wykrojnik_sel_old
          this.predkosc_druku = 33
          if (this.wykrojnik.koszt_1K.predkosc_druku)
          this.predkosc_druku = this.wykrojnik.koszt_1K.predkosc_druku

        }

        this.reindex();

        this.calc_prices_auto(undefined)

        this.reindex();

    }

    public money(v: number) {
        //return Number.parseFloat(parseFloat(<any>v).toFixed(2))
        return v;
    }

    public money2(v: number) {
        return Number.parseFloat(parseFloat(<any>v).toFixed(2))
    }
    public percent(v:number) {
        //return Number.parseFloat(parseFloat(<any>v).toFixed(2))
        return v;
    }

    reindex() {
        this.indexes = {}
        const fin=this.oferta.fin

        this.naklady=[]
        this.zmiany=[]
    
        for (let i=0;i<fin.naklady.list.length;i++) {
            const naklad = fin.naklady.list[i]
            this.naklady[i]=Number.parseFloat(parseFloat(<any>naklad).toFixed(2));
            if (!this.indexes[naklad]) this.indexes[naklad]={}
            if (fin.artworks.list.length==0) fin.artworks.list=[1]
            for (let j=0;j<fin.artworks.list.length;j++) {
                const zmian = fin.artworks.list[j]-1
                this.zmiany[j]=Number.parseFloat(parseFloat(<any>zmian).toFixed(0));
                if (this.indexes[naklad]) {
                    this.indexes[naklad][zmian] = { i:i, j:j}
                } else {
                    console.log(naklad, "this.indexes[naklad] undefined")
                }
            }
        }
    }

    explain_price(naklad:number, zmian:number, narzut:number):Licz {
        return this.calc_price(naklad, zmian, narzut)
    }

    explain_narzut(naklad:number, zmian:number, price:number):Licz {
        return this.calc_narzut(naklad, zmian, price)
    }

    get_price_auto(naklad:number, zmian:number):number {
        return  this.oferta.fin.prices_auto[naklad][zmian];
    }

    get_narzut_auto(naklad:number, zmian:number):number {
        return  this.oferta.fin.narzuty_auto[naklad][zmian];
    }

    get_price_manual(naklad:number, zmian:number):number {
        return this.oferta.fin.prices_auto[naklad][zmian];
    }

    get_narzut_manual(naklad:number, zmian:number):number {
        return this.oferta.fin.narzuty_auto[naklad][zmian];
    }
    
    get_price(naklad:number, zmian:number) {
        return this.oferta.fin.prices_auto[naklad][zmian];
    }

    get_narzut(naklad:number, zmian:number) {
        return this.oferta.fin.narzuty_auto[naklad][zmian];
    }

    
    calc_narzut(naklad:number, zmian:number, price: number) {
        const koszt_transportu =  Transport.get_koszt_transportu_dla_nakladu(this.oferta.transport,naklad)
        const przezbrojen = 1
        const narzut_auto = this.calc_narzut_auto(naklad, zmian);
        const narzut = OfertaCell.get_narzut(price, narzut_auto.get_x(), naklad, zmian, this.oferta.fin, koszt_transportu, this.wykrojnik, this.licz_w_pln);
        return narzut
    }


    calc_prices_auto(narzut_manual: number | undefined) {

        this.oferta.fin.prices_auto = {};
        this.oferta.fin.narzuty_auto = {};
        this.prices_auto_valid=false;
        
        for (let i=0;i<this.naklady.length;i++) {
            const naklad = this.naklady[i]
            for (let j=0;j<this.zmiany.length;j++) {
                const zmian = this.zmiany[j]
                if (!this.oferta.fin.prices_auto[naklad]) this.oferta.fin.prices_auto[naklad]={}
                if (!this.oferta.fin.narzuty_auto[naklad]) this.oferta.fin.narzuty_auto[naklad]={}

                /*
                let narzut_ = new Wartość("narzut_manual",narzut_manual);
                if (!narzut_manual) {
                    narzut_ = this.calc_narzut_auto(naklad, zmian);
                }
                */
                //const n:number = 1+(this.oferta.fin.narzut_procent_cel/100); 
                const narzut_ = new Wartość("narzut_manual",7.78);
                
                this.oferta.fin.narzuty_auto[naklad][zmian] = narzut_.get_x();
                this.oferta.fin.prices_auto[naklad][zmian] = this.calc_price(naklad, zmian, narzut_.get_x()).get_x();
                this.prices_auto_valid=true;
            }
        }
    }

    calc_price(naklad:number, zmian:number, narzut: number) {
        const koszt_transportu =  Transport.get_koszt_transportu_dla_nakladu(this.oferta.transport, naklad)
        const przezbrojen = 1
        const koszt = OfertaCell.get_price(narzut, naklad, zmian, this.oferta.fin, koszt_transportu, this.wykrojnik, this.licz_w_pln);
        return koszt;
    }


    calc_narzut_auto(naklad:number, zmian:number):ILicz {
        if (!this.narzut_procent_cel) return new Wartość("narzut_auto_błąd",9999);
        let narzut:number = this.narzut_procent_cel
        if (this.rodzaj_kalkulacji=="STARA KALKULACJA") {
            narzut = 0
        }
        const narzut_ = new Licz("narzut =  "+this.narzut_procent_cel)
        narzut_.set_x(narzut)
        return narzut_
    }
}
